import { InteractService } from './../services/interact.service';
import { Injectable } from '@angular/core';
import {
  NewEnvelopeSteps,
  NewEnvelopeStepsUtil,
} from '../../enum/new-envelope-steps';
import {
  StepperHorizontalEnum,
  IStepperHorizontal,
  ToastService,
  IToast,
  LayoutService,
  OnboardingService,
} from 'codex-lib';
import { BehaviorSubject, Subject, of, Subscription } from 'rxjs';
import { Signatory } from '../model/signatory';
import { FormGroup } from '@angular/forms';
import {
  MainEnvelope,
  MainEnvelopeToSend,
} from 'src/app/main-envelope/model/main-envelope.model';
import { EnvelopeService } from '../services/envelope.service';
import { FileEnvelopeService } from '../services/file-envelope.service';
import { EnvelopeFile } from 'src/app/main-envelope/model/envelope-file.model';
import { TranslateService } from '@ngx-translate/core';
import { RoutePages } from 'src/app/enum/route-pages';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Authorizer } from '../../model/authorizer';
import * as R from 'ramda';
import { SurvicateService } from 'src/app/services/survicate.service';
import { FileValidateService } from '../services/file-validate.service';
import { ListStampRubric } from '../model/list-stamp-rubric';
import { FeatureEnum } from 'src/app/enum/feature.enum';
import { EnvelopeOnBoardingService } from 'src/app/envelope/services/envelope-on-boarding.service';
import { BrowserUtil } from 'src/app/util/browser-util';
import { FileUtil } from 'src/app/util/file-utils';
import { ComponentDragDropService } from '../services/component-drag-drop.service';
import { PageUtil } from 'src/app/util/page-util';
import { StampsValidatorService } from '../services/stampsValidator.service';
import { Observer } from 'src/app/model/observer';
import { Responsible } from 'src/app/model/responsible';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';
import { CustomFieldTypeEnum } from 'src/app/enum/custom-field-type.enum';

const QUANTITY_OF_SIGNATURE_DEFAULT = 4;
const QUANTITY_OF_SIGNATURE_HEIGHT_DEFAULT = 48;
@Injectable({
  providedIn: 'root',
})
export class NewEnvelopeService {
  steps: IStepperHorizontal[] = [];
  modelData: Array<any>[4];
  currentStepSubject = new BehaviorSubject<IStepperHorizontal[]>(this.steps);
  stepModelSubject = new Subject<any>();
  fileFormData: FormData;
  filesList: File[];
  envelopeFiles: EnvelopeFile[];
  suffixBucketName: any;
  subscriptionFilesList: Subscription;
  filesUploaded: File[] = [];
  filesCancel: boolean;
  isMobile: boolean = BrowserUtil.isMobile();
  continueRoute;

  public filesUploads$ = new Subject<Array<EnvelopeFile>>();
  public fileSignatures$ = new Subject<any>();
  public includeRubrics$ = new Subject<boolean>();
  public includeComponent$ = new Subject<boolean>();
  public pageSelected$ = new Subject<string>();
  public updateDropdown$ = new Subject<void>();
  protected subjectFilesList = new BehaviorSubject<boolean>(false);
  private _includeRubrics = false;
  private _includeSignature = false;
  private _includeComponent = false;
  private _toggleDisabled = false;
  private _editMode = false;
  private _isFirstEnvelope = true;
  private _needCreateFirstEnvelope;

  constructor(
    private router: Router,
    private layoutService: LayoutService,
    private envelopeService: EnvelopeService,
    private fileEnvelopeService: FileEnvelopeService,
    private toastService: ToastService,
    private translate: TranslateService,
    private interactService: InteractService,
    private survicateService: SurvicateService,
    private onboardingService: OnboardingService,
    private envelopeOnBoardingService: EnvelopeOnBoardingService,
    public fileValidateService: FileValidateService,
    private componentDragDropService: ComponentDragDropService,
    private stampsvalidatorService: StampsValidatorService,
    private googleAnalitycsService: AnalyticsService
  ) {
    this.initModelData();
  }

  get editMode(): boolean {
    return this._editMode;
  }

  set editMode(value: boolean) {
    this._editMode = value;
  }

  get includeRubrics(): boolean {
    return this._includeRubrics;
  }

  set includeRubrics(value: boolean) {
    this.interactService.includeRubrics = value;
    this._includeRubrics = value;
  }

  get includeSignature(): boolean {
    return this._includeSignature;
  }

  set includeSignature(value: boolean) {
    this._includeSignature = value;
  }

  get includeComponent(): boolean {
    return this._includeComponent;
  }

  set includeComponent(value: boolean) {
    this._includeComponent = value;
    this.includeComponent$.next(value);
  }

  get toggleDisabled(): boolean {
    return this._toggleDisabled;
  }

  set toggleDisabled(value: boolean) {
    this._toggleDisabled = value;
  }

  get isFirstEnvelope(): boolean {
    return this._isFirstEnvelope;
  }

  set isFirstEnvelope(value: boolean) {
    this._isFirstEnvelope = value;
  }

  get needCreateFirstEnvelope(): boolean {
    return this._needCreateFirstEnvelope;
  }

  set needCreateFirstEnvelope(value: boolean) {
    this._needCreateFirstEnvelope = value;
  }

  public getLanguageEnvelope() {
    return this.getModelData(NewEnvelopeSteps.Settings)?.get('language')?.value
      .id;
  }

  setModelData(modelData: any) {
    const step = this.getCurrentStep();
    const index = NewEnvelopeStepsUtil.getEnvelopeStepIndex(step);
    switch (this.getCurrentStep()) {
      case NewEnvelopeSteps.Upload:
        this.modelData[index] = modelData as File[];
        break;
      case NewEnvelopeSteps.Settings:
        return (this.modelData[index] = modelData);
      case NewEnvelopeSteps.Signatory:
        this.modelData[index] = Object.assign({}, modelData);
        break;
      case NewEnvelopeSteps.Signatures:
        this.modelData[index] = Object.assign([], modelData);
        break;
      default:
        break;
    }

    this.stepModelSubject.next(this.modelData[index]);
    return this.modelData[index];
  }

  getModelData(step: NewEnvelopeSteps): any {
    const index = NewEnvelopeStepsUtil.getEnvelopeStepIndex(step);
    if (index < 0) {
      throw new Error('Step not valid');
    }
    return this.modelData[index];
  }

  public initModelData() {
    this.clearVariables();
    this.defineSteps();
  }

  isValidModelData(): boolean {
    const step = this.getCurrentStep();
    const index = NewEnvelopeStepsUtil.getEnvelopeStepIndex(step);
    switch (step) {
      case NewEnvelopeSteps.Upload:
        return R.pathOr(0, ['length'], this.modelData[index]) >= 1;
      case NewEnvelopeSteps.Settings:
        return (this.modelData[index] as FormGroup).valid;
      case NewEnvelopeSteps.Signatory:
        return true;
      case NewEnvelopeSteps.Signatures:
        return true;
      case NewEnvelopeSteps.Review:
        return true;
      default:
        break;
    }
  }

  isValidSignatoriesStep(step: NewEnvelopeSteps): boolean {
    const participants = this.getModelData(step);

    if (!participants.elements?.length) {
      this.showError('envelope.signatory.toast.required');
      return false;
    }

    var isValidObserver = !participants.observer || participants.envelopeObserver?.length > 0;
    var isValidAuthorizer = !participants.authorizer || participants.envelopeAuthorizers?.length > 0;
    var isValidResponsible = !participants.responsible || participants.envelopeResponsible?.length > 0;
    var isValidSignatoryTypeRole = !participants.elements.some(x => !x.signatoryTypeRole?.isActive);

    if (!isValidAuthorizer || (!isValidAuthorizer && !isValidObserver)) {
      this.showError('envelope.authorizer.toast.required');
      return false;
    }
    
    if (!isValidObserver) {
      this.showError('envelope.observer.toast.required');
      return false;
    }

    if (!isValidResponsible) {
      this.showError('envelope.responsible.toast.required');
      return false;
    }

    if (!isValidSignatoryTypeRole) {
      this.showError('envelope.signatory.toast.signatoryTypeRoleInactive');
      return false;
    }

    return true;
  }

  private showError(error: string): void {
    const toast: IToast = {
      text: this.translate.instant(error),
      autoHide: true,
      type: 'danger'
    };

    this.toastService.createNewToast(toast);
  }

  validateSignatures() {
    const signatoryStepModel = this.getModelData(NewEnvelopeSteps.Signatory);
    const hasResponsibles = (signatoryStepModel?.envelopeResponsible as Array<Responsible>)?.length > 0;
    
    var isValidForm = true;
    if (hasResponsibles && this.interactService.customFields.length === 0) {
      isValidForm = false;
    }

    let signatorys = this.getModelData(NewEnvelopeSteps.Signatory)['elements'];
    let exits = true;
    signatorys.forEach((signatory: Signatory) => {
      this.envelopeFiles.forEach((file) => {
        if (exits) {
          exits = this.interactService.signatoryStamps.some(
            (signatoryStamp) =>
              parseInt(signatoryStamp.signatoryId) == signatory.id &&
              signatoryStamp.fileName === FileUtil.removeExt(file.name)
          );
        }
      });
    });

    return {
      isValidStamps: this.interactService.signatoryStamps.length > 0 && this.interactService.signatoryStamps.every((x) => !x.invalid) && exits,
      isValidForm: isValidForm && this.interactService.customFields.every((x) => !x.invalid) && exits,
      isValidRubrics: this.interactService.rubricStamps.every((x) => !x.invalid) && exits
    };
  }

  public getCurrentStep(): NewEnvelopeSteps {
    let currentStepElement: IStepperHorizontal;
    this.steps.some((element) => {
      if (element.status === StepperHorizontalEnum.ACTIVE) {
        currentStepElement = element;
        return element.status === StepperHorizontalEnum.ACTIVE;
      }
    });

    return NewEnvelopeStepsUtil.getEnvelopeStep(currentStepElement.name);
  }

  stepNext(): boolean {
    this.layoutService.toggleLoading(true);
    const step = this.getCurrentStep();
    const index = NewEnvelopeStepsUtil.getEnvelopeStepIndex(step);

    if (step !== NewEnvelopeSteps.Review) {
      if (step === NewEnvelopeSteps.Upload) {
        this.sendFiles();
      }

      if (step === NewEnvelopeSteps.Signatures) {
        
        var validateResult = this.validateSignatures();
        
        const isvalidStep = validateResult.isValidStamps 
          && validateResult.isValidRubrics 
          && validateResult.isValidForm;

        const isMissingCustomFields = this.includeComponent && this.interactService.customFields.length === 0;

        if (!isvalidStep) {
          if (!validateResult.isValidStamps || !validateResult.isValidRubrics)
            this.buildToastInvalidStep('envelope.main-envelope.toast.pendingDocuments', 'warning');
          else if (isMissingCustomFields)
            this.buildToastInvalidStep('envelope.main-envelope.toast.requiredFormFields', 'danger');
          else if (!validateResult.isValidForm)
            this.buildToastInvalidStep('envelope.main-envelope.toast.overlappingFields', 'warning');

          this.layoutService.toggleLoading(false);
          return false;
        }

        const modelSignature = new ListStampRubric(
          this.interactService.signatoryStamps,
          this.interactService.rubricStamps,
          this.interactService.customFields
        );
        this.setModelData(modelSignature);
      }

      this.steps[index].status = StepperHorizontalEnum.DONE;
      this.steps[index + 1].status = StepperHorizontalEnum.ACTIVE;
      this.currentStepSubject.next(this.steps);
      this.layoutService.toggleLoading(false);
    } else {
      this.survicateService.onCreateEnvelope();
      this.observer();

      this.googleAnalitycsService.sendEvent(
        new TrackerData(
          AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
          'Signer_NovEnv_Enviar'
        )
      );
    }

    return true;
  }

  cancelEnvelope() {
    this.fileValidateService.fileConfig = [];
    this.interactService.emptyStampRubricParams();
    this.interactService.emptySignatureAndRubricElements();
    this.setCancelList(true);
    this.filesList = [];

    if (this.subscriptionFilesList !== undefined) {
      this.subscriptionFilesList.unsubscribe();
    }

    if (R.pathOr(0, ['length'], this.envelopeFiles) >= 1) {
      this.fileEnvelopeService
        .deleteFiles(this.envelopeFiles.map((x) => x.id))
        .subscribe();
    }
  }

  setCancelList(value: boolean) {
    this.filesCancel = value;
  }

  getCancelList(): boolean {
    return this.filesCancel;
  }

  processNextEntry() {
    if (this.filesList.length > 0) {
      this.processFilesQueue(this.filesList[0]);
    }
  }

  setSubject(subject: boolean) {
    this.subjectFilesList.next(subject);
  }

  getSubject(): Observable<boolean> {
    return this.subjectFilesList.asObservable();
  }

  setSubjectFilesUploads(envelopeFiles: EnvelopeFile[]) {
    this.envelopeFiles = Object.assign([], envelopeFiles);
    this.filesUploads$.next(envelopeFiles);
  }

  getSubjectFilesUploads(): Observable<EnvelopeFile[]> {
    return this.filesUploads$.asObservable();
  }

  getSubjectfileSelected(): Observable<any> {
    return this.fileSignatures$.asObservable();
  }

  setSubjectfileSelected(data: any) {
    this.fileSignatures$.next(data);
  }

  getSubjectIncludeRubrics(): Observable<any> {
    return this.includeRubrics$.asObservable();
  }

  setSubjectIncludeRubrics(data: any) {
    this.includeRubrics$.next(data);
  }

  getSubjectPageSelected(): Observable<string> {
    return this.pageSelected$.asObservable();
  }

  setSubjectPageSelected(data: string) {
    this.pageSelected$.next(data);
  }

  getSubjectUpdateDropdown(): Observable<void> {
    return this.updateDropdown$.asObservable();
  }

  observer() {
    if (this.getCurrentStep() === NewEnvelopeSteps.Review) {
      this.subscriptionFilesList = this.getSubject().subscribe((subject) => {
        if (this.filesList.length === 0) {
          if (this.interactService.signatoryStamps.length === 0) {
            this.layoutService.toggleLoading(false);
            const toast: IToast = {
              text: this.translate.instant(
                'businessError.inconsistencySignatures'
              ),
              autoHide: true,
              type: 'warning',
            };
            this.toastService.createNewToast(toast);
            return;
          }
          const envelope = this.generateSendEnvelope();

          // if (this.interactService.signatoryStamps.length !== (envelope.signatories.length * envelope.files.length)) {
          //   this.layoutService.toggleLoading(false);
          //   const toast: IToast = {
          //     text: this.translate.instant('businessError.inconsistencySignatures')
          //     , autoHide: true, type: 'warning'
          //   };
          //   this.toastService.createNewToast(toast);
          //   return;
          // }

          this.sendFormData(envelope);
        }
      });
    }
  }

  getDataListFiles() {
    const modelData = this.getModelData(NewEnvelopeSteps.Upload);
    const filesToUpload = [];

    modelData.forEach((file) => {
      const index = this.filesUploaded.indexOf(file);
      if (index === -1) {
        filesToUpload.push(file);
      }
    });

    this.filesList = Object.assign([], filesToUpload);
  }

  setFileFormData(file) {
    this.filesUploaded.push(file);
    this.fileFormData = new FormData();
    this.fileFormData.append('file', file, file.name);
  }

  setEnvelopeFiles(file) {
    if (!this.getCancelList()) {
      setTimeout(() => {
        this.envelopeFiles = this.envelopeFiles.map((item) => {
          if (FileUtil.removeExt(item.name) === FileUtil.removeExt(file.name)) {
            item.upload = true;
            item.id = file.id;
            item.name = file.name;
            item.fileAlreadySigned = file.fileAlreadySigned;
          }
          return item;
        });
        this.setSubjectFilesUploads(this.envelopeFiles);
      });
    } else {
      this.fileEnvelopeService
        .deleteFiles(this.envelopeFiles.map((x) => x.id))
        .subscribe();
      this.suffixBucketName = null;
    }
  }

  getFilesUploads(): EnvelopeFile[] {
    return this.envelopeFiles;
  }

  deleteFilesUploads(indexFile: number) {
    this.deleteFileBucket(indexFile);
    this.deleteFileIndex(indexFile);
  }

  stepBack() {
    const step = this.getCurrentStep();
    const index = NewEnvelopeStepsUtil.getEnvelopeStepIndex(step);
    this.steps[index].status = null;
    if (step !== NewEnvelopeSteps.Upload) {
      this.steps[index - 1].status = StepperHorizontalEnum.ACTIVE;
    }
    this.currentStepSubject.next(this.steps);
  }

  sendFormData(envelope) {
    this.envelopeService.insert(envelope).subscribe(
      (next) => {
        this.interactService.emptyStampRubricParams();
        this.interactService.emptySignatureAndRubricElements();
        this.envelopeSendFormSuccess();
        this.subscriptionFilesList.unsubscribe();
        this.suffixBucketName = null;
        this.router
          .navigate([RoutePages.SentEnvelope])
          .then((x) => this.initModelData());
      },
      (error) => {
        this.envelopeSendFormError(error);
      }
    );
  }

  envelopeSendFormError(error) {
    this.layoutService.toggleLoading(false);
  }

  envelopeSendFormSuccess() {
    this.openOnBoardingFirstEnvelope();
    this.layoutService.toggleLoading(false);
    const toast: IToast = {
      text: this.translate.instant('envelope.review.toast.sendSuccess'),
      autoHide: true,
      type: 'success',
    };
    this.toastService.createNewToast(toast);
    this.layoutService.toggleButtonCofirmGoBack(true);
    this.layoutService.toggleViewer(false);
  }

  openOnBoardingFirstEnvelope() {
    if (this.survicateService.isSignFree() && this._isFirstEnvelope) {
      this._isFirstEnvelope = false;
    }

    if (this.survicateService.isSignFree()) {
      this.envelopeOnBoardingService
        .verifyViewed(FeatureEnum.firstEnvelope)
        .subscribe((dataRubric) => {
          if (!dataRubric) {
            this.router.navigate([RoutePages.Dashboard]);
          } else {
            this.router
              .navigate([RoutePages.Dashboard])
              .then((x) => this.initModelData());
          }
        });
    } else {
      this.router.navigate([RoutePages.Root]).then((x) => this.initModelData());
    }
  }

  activateEditMode() {
    const pages = document.getElementsByClassName('page');
    for (let index = 0; index < pages.length; index++) {
      const element = pages[index] as HTMLElement;
      element.style.opacity = '0.8';
    }

    const signatures = document.getElementsByClassName('signature-image');
    for (let index = 0; index < signatures.length; index++) {
      const element = signatures[index] as HTMLElement;
      element.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
      element.style.border = '1px dashed green';
      element.style.pointerEvents = 'auto';
    }
    this.interactService.startInteract('signature', 'dropzone');

    const rubrics = document.getElementsByClassName('rubric-image');
    for (let index = 0; index < rubrics.length; index++) {
      const element = rubrics[index] as HTMLElement;
      element.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
      element.style.border = '1px dashed green';
      element.style.pointerEvents = 'auto';
    }
    this.interactService.startInteract('rubric', 'dropzone');
    this.interactService.startInteract(CustomFieldTypeEnum.TextField, 'dropzone');
    this.interactService.startInteract(CustomFieldTypeEnum.CheckboxField, 'dropzone');
    this._editMode = true;
  }

  deactivateEditMode() {
    const pages = document.getElementsByClassName('page');
    for (let index = 0; index < pages.length; index++) {
      const element = pages[index] as HTMLElement;
      element.style.opacity = '1';
    }

    const signatures = document.getElementsByClassName('signature-image');
    for (let index = 0; index < signatures.length; index++) {
      const element = signatures[index] as HTMLElement;
      element.style.backgroundColor = 'rgba(0, 0, 0, 0)';
      element.style.border = '1px dashed rgba(0, 0, 0, 0)';
      element.style.pointerEvents = 'none';
    }
    this.interactService.stopInteract('signature');

    const rubrics = document.getElementsByClassName('rubric-image');
    for (let index = 0; index < rubrics.length; index++) {
      const element = rubrics[index] as HTMLElement;
      element.style.backgroundColor = 'rgba(0, 0, 0, 0)';
      element.style.border = '1px dashed rgba(0, 0, 0, 0)';
      element.style.pointerEvents = 'none';
    }
    this.interactService.stopInteract('rubric');
    this.interactService.stopInteract(CustomFieldTypeEnum.TextField);
    this.interactService.stopInteract(CustomFieldTypeEnum.CheckboxField);
    this._editMode = false;
  }

  includeSignatureMode() {
    let isToastFilePreviouslySigned = false;

    if (this.includeSignature == false) return;
    let signatories = this.getModelData(NewEnvelopeSteps.Signatory)[
      'elements'
    ] as Array<Signatory>;

    if (signatories) {
      if (!this.verifySignatoriesLimit()) return;

      signatories = this.interactService.isOrdered
        ? signatories.sort((a, b) => (a.order < b.order ? -1 : 1))
        : signatories;

      let exitsAnySignature = this.interactService.signatoryStamps?.length > 0;
      if (
        exitsAnySignature &&
        !this.interactService.withRubrics &&
        !this.isMobile
      ) {
        const toast: IToast = {
          text: this.translate.instant('businessError.rubricWarning'),
          autoHide: true,
          type: 'warning',
        };
        this.toastService.createNewToast(toast);
      }

      this.includeSignature = true;

      this.layoutService.toggleLoading(true);

      for (const config of this.fileValidateService.fileConfig.filter(
        (x) => x.last
      )) {
        let order = 1;
        let signatoriesCount = 0;
        let page = config.length;
        signatories.forEach((signatory) => {
          let signatureExits = false;
          if (!this.interactService.withRubrics || this.isMobile) {
            signatureExits = this.validateSignatureExistsInFile(
              signatory.id,
              config.fileName
            );
          }

          if (this.isMobile) {
            this.excludeAllSignature();
          }

          if (this.validateSignatureExistsInFile(signatory.id, config.fileName) &&
            this.envelopeFiles.some(x => x.fileAlreadySigned)) {
            isToastFilePreviouslySigned = true;
            return;
          }

          if (!signatureExits || this.isMobile) {
            if (
              this.verifySignaturesLimitPage(config.height, config.width) ==
              signatoriesCount
            ) {
              order = 1;
              page = page - 1;
              signatoriesCount = 0;
            }
            let envelopeFileSelected = this.envelopeFiles.find(
              (x) =>
                x.checked == true &&
                FileUtil.removeExt(x.name) == config.fileName
            );
            let calculateSignature =
              PageUtil.calculateCoordenatesDefaultSignatureOnPagePx(
                config.height,
                config.width,
                order,
                page
              );
            this.componentDragDropService.createElementSignatureAddStamp(
              config.fileName,
              signatory,
              parseInt(calculateSignature.page),
              calculateSignature.x,
              calculateSignature.y,
              calculateSignature.adjustMarginY,
              true,
              envelopeFileSelected?.checked ?? false
            );
            order++;
            signatoriesCount++;
          }
        });
      }

      this.layoutService.toggleLoading(false);
      this.updateDropdown$.next();
      if (isToastFilePreviouslySigned) this.toastFilePreviouslySigned('signature');
    }
  }

  toastFilePreviouslySigned(type: 'rubric' | 'signature') {
    const toast: IToast = {
      text: this.translate.instant(type === 'signature' ?
         'businessError.twoOrMoreStampsPreviouslySignedDoc' : 
         'businessError.rubricPreviouslySignedDoc'),
      autoHide: true,
      type: 'warning'
    };
    this.toastService.createNewToast(toast);
  }

  verifySignaturesLimitPage(heightInPx: number, widthInPx: number) {
    const quantityRubricsOnPage =
      widthInPx > 0
        ? PageUtil.getQuantityOfSignatureOnPage(10, 185, widthInPx)
        : QUANTITY_OF_SIGNATURE_DEFAULT;

    const quantityRubricsOnPageHeight =
      heightInPx > 0
        ? PageUtil.getQuantityOfSignatureOnPageHeight(5, 85, heightInPx)
        : QUANTITY_OF_SIGNATURE_HEIGHT_DEFAULT;

    return quantityRubricsOnPage * quantityRubricsOnPageHeight;
  }

  verifySignatoriesLimit(): boolean {
    var signatories = this.getModelData(NewEnvelopeSteps.Signatory)[
      'elements'
    ] as Array<Signatory>;
    var document = this.fileValidateService.fileConfig.filter((x) => x.last);
    var limitDocument =
      this.verifySignaturesLimitPage(document[0].height, document[0].width) *
      document[0].length;
    if (signatories.length > limitDocument) {
      this.toastStampLimit();
      this.toggleDisabled = true;
      this.includeSignature = false;
      this.excludeAllSignature();
      return false;
    }
    this.toggleDisabled = false;

    return true;
  }

  toastStampLimit() {
    const toast: IToast = {
      text: this.translate.instant('toastLimitStamp'),
      autoHide: true,
      type: 'info',
    };
    this.toastService.createNewToast(toast);
  }

  excludeSignatureMode() {
    this.includeSignature = false;
    document
      .querySelectorAll('.signature-default')
      .forEach((el) => el.remove());
    this.interactService.deleteStampParamsDefault();
    this.stampsvalidatorService.onAfterCheckStamps();
    this.updateDropdown$.next();
  }

  excludeSignatureFile(fileName: string) {
    document.querySelectorAll('.signature').forEach((el) => el.remove());
    this.interactService.deleteStampParams(FileUtil.removeExt(fileName));
    this.validateSignatures();
    this.stampsvalidatorService.onAfterCheckStamps();
    this.updateDropdown$.next();
  }

  excludeAllSignature() {
    document.querySelectorAll('.signature').forEach((el) => el.remove());
    this.interactService.deleteAllStampParams();
    this.validateSignatures();
    this.updateDropdown$.next();
  }

  excludeRubricFile(fileName: string) {
    this.includeRubrics = false;
    document.querySelectorAll('.rubric').forEach((el) => el.remove());
    this.interactService.deleteRubricsParams(FileUtil.removeExt(fileName));
    this.stampsvalidatorService.onAfterCheckStamps();
    this.updateDropdown$.next();
  }

  excludeAllRubric() {
    this.includeRubrics = false;
    document.querySelectorAll('.rubric').forEach((el) => el.remove());
    this.interactService.deleteAllRubricsParams();
    this.stampsvalidatorService.onAfterCheckStamps();
    this.updateDropdown$.next();
  }

  excludeAllCustomFields() {
    document.querySelectorAll(`.${CustomFieldTypeEnum.TextField}`).forEach((el) => el.remove());
    document.querySelectorAll(`.${CustomFieldTypeEnum.CheckboxField}`).forEach((el) => el.remove());
    this.interactService.deleteAllCustomFieldsParams();
    this.stampsvalidatorService.onAfterCheckStamps();
    this.updateDropdown$.next();
  }

  excludeSingleStamp(dataGid: string) {
    document
      .querySelectorAll('[data-gid="' + dataGid + '"]')
      .forEach((el) => el.remove());
    this.interactService.deleteSingleStampParams(dataGid);
    this.validateSignatures();
    this.toastExcludSingleStamp();
    this.stampsvalidatorService.onAfterCheckStamps();
    this.updateDropdown$.next();
  }

  excludeSingleRubric(dataGid: string) {
    document
      .querySelectorAll('[data-gid="' + dataGid + '"]')
      .forEach((el) => el.remove());
    this.interactService.deleteSingleRubricParams(dataGid);
    this.toastExcludSingleRubric();
    this.stampsvalidatorService.onAfterCheckStamps();
    this.updateDropdown$.next();
  }

  excludeSingleCustomField(dataGid: string) {
    document.querySelectorAll('[data-gid="' + dataGid + '"]').forEach((el) => el.remove());
    this.interactService.deleteSingleCustomFieldParams(dataGid);
    this.stampsvalidatorService.onAfterCheckStamps();
    this.updateDropdown$.next();
  }

  toastExcludSingleStamp() {
    const toast: IToast = {
      text: this.translate.instant('toastExcludeSingleStamp'),
      autoHide: true,
      type: 'success',
    };
    this.toastService.createNewToast(toast);
  }

  toastExcludSingleRubric() {
    const toast: IToast = {
      text: this.translate.instant('toastExcludeSingleRubric'),
      autoHide: true,
      type: 'success',
    };
    this.toastService.createNewToast(toast);
  }

  includeRubricMode() {
    let signatories = this.getModelData(NewEnvelopeSteps.Signatory)[
      'elements'
    ] as Array<Signatory>;

    if (signatories) {
      signatories = this.interactService.isOrdered
        ? signatories.sort((a, b) => (a.order < b.order ? -1 : 1))
        : signatories;

      this.includeRubrics = true;

      for (const config of this.fileValidateService.fileConfig.filter(
        (x) => x.length
      )) {
        let order = 1;
        signatories.forEach((signatory) => {
          let exitsSignature = this.interactService.signatoryStamps?.some(
            (y) =>
              y.fileName == config.fileName &&
              y.signaturePositionPage == config.page &&
              y.signatoryId == signatory.id.toString()
          );

          if (!exitsSignature) {
            let envelopeFileSelected = this.envelopeFiles.find(
              (x) =>
                x.checked == true &&
                FileUtil.removeExt(x.name) == config.fileName
            );
            let calculateSignature =
              PageUtil.calculateCoordenatesDefaultRubricOnPagePx(
                config.height,
                config.width,
                order
              );
            this.componentDragDropService.createElementRubricAddStamp(
              config.fileName,
              signatory,
              parseInt(config.page),
              calculateSignature.x,
              calculateSignature.y,
              true,
              envelopeFileSelected?.checked ?? false
            );
            order++;
          }
        });
      }
      this.updateDropdown$.next();
    }
  }

  excludeRubricMode() {
    this.includeRubrics = false;
    document.querySelectorAll('.rubric-default').forEach((el) => el.remove());
    this.interactService.deleteRubricParamsDefault();
    this.updateDropdown$.next();
  }

  restoreSignatures() {
    this.interactService.restoreInitialPosition('signature');
  }

  restoreRubrics() {
    this.interactService.restoreInitialRubricPosition('rubric');
  }

  validateSignatoresOnFileByFileName(fileName: any) {
    const signatories = this.getModelData(NewEnvelopeSteps.Signatory)['elements'];
    let exits = true;
    if (signatories) {
      signatories.forEach((signatory: Signatory) => {
        if (exits) {
          exits = this.interactService.signatoryStamps.some(
            (signatoryStamp) =>
              parseInt(signatoryStamp.signatoryId) == signatory.id &&
              signatoryStamp.fileName === FileUtil.removeExt(fileName)
          );
        }
      });
      
      this.stampsvalidatorService.onAfterCheckStamps();
      return {
        isValidStamps: this.interactService.signatoryStamps.length > 0 && this.interactService.signatoryStamps.every((x) => !x.invalid) && exits,
        isValidForm: this.interactService.customFields.every((x) => !x.invalid) && exits,
        isValidRubrics: this.interactService.rubricStamps.every((x) => !x.invalid) && exits
      };
    }
  }

  validateSignatureExistsInFile(
    signatoryId: number,
    fileName: string
  ): boolean {
    return this.interactService.signatoryStamps?.some(
      (y) =>
        y.fileName == FileUtil.removeExt(fileName) &&
        y.signatoryId == signatoryId.toString()
    );
  }

  updateObserver(updatedObserver: Observer, listObserver: any): void {
    const index = listObserver.findIndex(
      obs => obs.id === updatedObserver.id
    );
    if (index !== -1) {
      listObserver[index] = { ...updatedObserver };
    }
    return listObserver;
  }

  private sendFiles() {
    this.getDataListFiles();
    if (this.filesList.length > 0) {
      this.processFilesQueue(this.filesList[0]);
    }
  }
  private defineSteps() {
    this.steps = [
      {
        name: NewEnvelopeSteps.Upload,
        status: StepperHorizontalEnum.ACTIVE,
      },
      {
        name: NewEnvelopeSteps.Settings,
      },
      {
        name: NewEnvelopeSteps.Signatory,
      },
      {
        name: NewEnvelopeSteps.Signatures,
      },
      {
        name: NewEnvelopeSteps.Review,
      },
    ];

    this.currentStepSubject.next(this.steps);
  }

  private clearVariables() {
    this.envelopeFiles = [];
    this.suffixBucketName = null;
    this.filesUploaded = [];
    this.modelData = new Array<any>([], {}, {}, {});
    this.includeRubrics = false;
    this.includeSignature = false;
    this.includeComponent = false;
  }

  private processFilesQueue(item) {
    this.setSubject(false);
    this.setFileFormData(item);
    this.setCancelList(false);
    this.fileEnvelopeService
      .insert(this.fileFormData, this.suffixBucketName)
      .pipe(
        switchMap((ev: EnvelopeFile) => {
          ev.upload = true;
          this.suffixBucketName =
            this.suffixBucketName == null
              ? ev.suffixBucketName
              : this.suffixBucketName;
          this.setEnvelopeFiles(ev);
          return of(true);
        })
      )
      .subscribe((x) => {
        const index = this.filesList.indexOf(item);
        if (index !== -1) {
          this.filesList.splice(index, 1);
          R.pathOr(0, ['length'], this.filesList) >= 1
            ? this.processNextEntry()
            : this.setSubject(true);
        }
      });
  }

  private deleteFileIndex(indexFile: number) {
    this.envelopeFiles.splice(indexFile, 1);
    this.filesUploaded.splice(indexFile, 1);
    this.modelData[0].splice(indexFile, 1);
    if (this.envelopeFiles.length == 0) {
      this.includeSignature = false;
      this.includeRubrics = false;
    }
  }

  private deleteFileBucket(indexFile: number) {
    const envelopeFileId: Array<number> = [];
    const envelopeFilesUploads = this.getFilesUploads();
    if (envelopeFilesUploads[indexFile] === undefined) {
      return;
    }
    if (
      envelopeFilesUploads.length !== 0 &&
      envelopeFilesUploads[indexFile].id !== undefined
    ) {
      const id = envelopeFilesUploads[indexFile].id;
      if (id == null) {
        return;
      }

      envelopeFileId.push(id);
      this.fileEnvelopeService.deleteFiles(envelopeFileId).subscribe();
      this.fileValidateService.deleteFileConfig(
        FileUtil.removeExt(envelopeFilesUploads[indexFile].name)
      );
      this.interactService.deleteStampParams(
        FileUtil.removeExt(envelopeFilesUploads[indexFile].name)
      );
      this.interactService.deleteRubricsParams(
        FileUtil.removeExt(envelopeFilesUploads[indexFile].name)
      );
      this.interactService.deleteCustomFieldsParams(
        FileUtil.removeExt(envelopeFilesUploads[indexFile].name)
      );
    }
  }

  private generateSendEnvelope(): MainEnvelopeToSend {
    const envelope = new MainEnvelope();
    envelope.addSettings(
      (this.getModelData(NewEnvelopeSteps.Settings) as FormGroup).value
    );
    envelope.addSignatory(this.getModelData(NewEnvelopeSteps.Signatory));
    envelope.addAuthorizers(this.getModelData(NewEnvelopeSteps.Signatory));
    envelope.addObservers(this.getModelData(NewEnvelopeSteps.Signatory));
    envelope.addResponsibles(this.getModelData(NewEnvelopeSteps.Signatory));
    const stepSignature = this.getModelData(NewEnvelopeSteps.Signatures);
    if (stepSignature.stamps) {
      envelope.addSignatoryStamps(stepSignature.stamps);
    }
    if (stepSignature.rubrics) {
      envelope.addSignatoryRubrics(stepSignature.rubrics);
    }
    if (stepSignature.customFields) {
      envelope.addSignatoryCustomFields(stepSignature.customFields);
    }
    envelope.addFilesAndSuffixBucketName(
      this.envelopeFiles
        .filter((x) => x.upload)
        .map((y) => ({ id: y.id, fileName: y.name })),
      this.fileValidateService.fileConfig,
      this.suffixBucketName
    );

    var envelopeToSend = envelope.generateSend();
    envelopeToSend.hasFileAlreadySigned = this.envelopeFiles.some(x => x.fileAlreadySigned);

    return envelopeToSend;
  }
  
  private buildToastInvalidStep(message : string, type: string) {
    const toast: IToast = {
      text: this.translate.instant(message),
      autoHide: true,
      type: type
    };
    
    this.toastService.createNewToast(toast);
  }
}
